import { useState } from 'react';
import { reviews } from '@/mocks/comics';

export default function ReviewsSection() {
  const [activeReview, setActiveReview] = useState(0);

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-label="读者评价">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
            Reviews
          </span>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-foreground-950 mt-2">
            漫友口碑
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            来自真实读者的评价，073漫画网用心做好每一次阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`w-3 h-3 flex items-center justify-center text-xs ${
                          i < review.rating
                            ? 'ri-star-fill text-amber-400'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                "{review.content}"
              </p>
              <p className="text-xs text-foreground-500 mt-3">{review.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}